// Original auto-haus.app hero clips. Replace via REACT_APP_HERO_VIDEOS (comma-separated mp4 URLs) or here.
const ORIGINAL_HERO = {
  videos: [
    "https://videos.pexels.com/video-files/5309351/5309351-hd_1920_1080_25fps.mp4",
    "https://videos.pexels.com/video-files/5309345/5309345-hd_1920_1080_25fps.mp4",
    "https://videos.pexels.com/video-files/5309381/5309381-hd_1920_1080_25fps.mp4",
  ],
  poster:
    "https://images.unsplash.com/photo-1708781055870-5ac2a90bbef0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920",
  sceneDuration: 8000,
};

const envVideos = (process.env.REACT_APP_HERO_VIDEOS || "").split(",").map((s) => s.trim()).filter(Boolean);
const HERO = envVideos.length
  ? { ...ORIGINAL_HERO, videos: envVideos, poster: process.env.REACT_APP_HERO_POSTER || ORIGINAL_HERO.poster }
  : ORIGINAL_HERO;

const autohaus = {
  id: "autohaus",
  company: {
    name: "IHR AUTOHAUS",
    legalName: "Muster Autohaus GmbH",
    owner: "Max Mustermann",
    street: "Musterstraße 1",
    city: "12345 Musterstadt",
    region: "Musterstadt",
    country: "Deutschland",
    countryCode: "DE",
    phone: "+49 123 4567890",
    phoneLink: "tel:+491234567890",
    email: "info@ihr-autohaus.de",
    whatsapp: "https://wa.me/491234567890",
    mapsQuery: "Deutschland",
    hours: [
      ["Montag – Freitag", "09:00 – 18:00 Uhr"],
      ["Samstag", "10:00 – 14:00 Uhr"],
      ["Sonntag", "Geschlossen"],
    ],
    appointmentOnly: false,
    logo: null,
    legal: {
      register: "HRB 00000", court: "Amtsgericht Musterstadt", vatId: "DE 000000000",
      seat: null, purpose: null, chamber: null, authority: null,
    },
  },
  features: { financing: true, ai: true, reservation: true, reviews: true, ankauf: true, findet: true, vehicleForms: true },
  hero: HERO,
  copy: {
    heroEyebrow: "Premium-Sportwagen",
    heroTitle: "Exklusive Sportwagen.",
    heroSubtitle: "Ehrlich. Transparent. Persönlich.",
    heroLine: "",
    tagline: "Exklusive Sportwagen. Ehrlich. Transparent. Persönlich.",
    seoTitle: "Ihr Autohaus – Exklusive Sportwagen",
    seoDescription: "Exklusive Sportwagen von Porsche, Ferrari, AMG & mehr. Ehrlich. Transparent. Persönlich.",
  },
  waGreeting: "Hallo, ich habe Interesse an einem Fahrzeug bei IHR AUTOHAUS.",
  waVehicle: (v, url) => `Hallo, ich interessiere mich für den ${v.title}. ${url}`,
};

const vehicleLabel = (v) => v.title || [v.brand, v.model, v.variant].filter(Boolean).join(" ");
const num = (n) => new Intl.NumberFormat("de-AT").format(n);
const vehicleFacts = (v) =>
  [
    v.first_registration ? `EZ ${v.first_registration}` : v.year ? `Baujahr ${v.year}` : "",
    v.mileage ? `${num(v.mileage)} km` : "",
    v.price ? `€ ${num(v.price)}` : "",
  ].filter(Boolean).join(", ");

const admotors = {
  id: "admotors",
  company: {
    name: "AD MOTORS",
    legalName: "AD MOTORS GmbH",
    since: 2021,
    owner: "Adel Karić",
    street: "Schusterstraße 10A",
    city: "2482 Münchendorf",
    region: "Münchendorf",
    country: "Österreich",
    countryCode: "AT",
    phone: "+43 676 5507777",
    phoneLink: "tel:+436765507777",
    email: "office@admotors.at",
    whatsapp: "https://wa.me/436765507777",
    instagram: { url: "https://www.instagram.com/admotors.at/", handle: "@admotors.at" },
    mapsQuery: "Schusterstraße 10A, 2482 Münchendorf, Österreich",
    hours: null,
    appointmentOnly: true,
    logo: "/brands/admotors/logo.svg",
    logoDark: "/brands/admotors/logo-dark.svg",
    legal: {
      register: "FN 642803z",
      court: "Handelsgericht Wien",
      vatId: "ATU81730049",
      seat: { street: "Malborghetgasse 27–29/7/14", city: "1100 Wien" },
      purpose: "Handel mit Neu- und Gebrauchtfahrzeugen",
      bank: { name: "Raiffeisenbank Wolkersdorf-Auersthal", iban: "AT75 3295 1000 0011 5519", bic: "RLNWATWWWDF" },
      intro: "Wir nehmen Verantwortung genauso ernst wie jedes Fahrzeug, das unseren Showroom verlässt. Hier finden Sie alle Fakten zu AD MOTORS – vielleicht nicht ganz so aufregend wie eine Probefahrt, aber mindestens genauso wichtig.",
      chamber: null,
      authority: null,
    },
  },
  features: { financing: false, ai: false, reservation: false, reviews: false, ankauf: false, findet: false, vehicleForms: false },
  hero: {
    videos: [`${process.env.PUBLIC_URL}/brands/admotors/hero-1080.mp4`],
    mobileVideos: [`${process.env.PUBLIC_URL}/brands/admotors/hero-mobile.mp4`],
    poster: `${process.env.PUBLIC_URL}/brands/admotors/hero-poster.jpg`,
    credit: {
      title: "Two Porsche 911 Targa driving as viewed from FPV drone",
      author: "SE FPV",
      source: "https://commons.wikimedia.org/wiki/File:Two_Porsche_911_Targa_driving_as_viewed_from_FPV_drone.webm",
      license: "CC BY 3.0",
      licenseUrl: "https://creativecommons.org/licenses/by/3.0/deed.de",
    },
  },
  copy: {
    heroEyebrow: "Sportwagen & Premiumfahrzeuge · Münchendorf",
    heroTitle: "Außergewöhnliche Fahrzeuge.",
    heroSubtitle: "Persönlich ausgewählt.",
    heroPsSubtitle: "bei uns im Showroom.",
    heroLine: "Sportwagen & Premiumfahrzeuge in Münchendorf.",
    tagline: "Außergewöhnliche Fahrzeuge. Persönlich ausgewählt.",
    seoTitle: "AD MOTORS – Sportwagen & Premiumfahrzeuge in Münchendorf",
    seoDescription:
      "AD MOTORS GmbH – Sportwagen & Premiumfahrzeuge in Münchendorf. Aktueller Fahrzeugbestand, Besichtigung nach Terminvereinbarung, Anfrage per WhatsApp.",
  },
  waGreeting: "Hallo AD Motors, ich interessiere mich für ein Fahrzeug auf Ihrer Website.",
  // Fixed selection of real Google reviews (copied once, Oct 2026).
  googleReviews: {
    rating: 5,
    url: "https://www.google.com/maps/search/?api=1&query=AD+MOTORS+Schusterstra%C3%9Fe+10A+2482+M%C3%BCnchendorf",
    items: [
      { name: "Almina D.", stars: 5, text: "Ich weiß gar nicht, wo ich anfangen soll! Dieser Autohändler ist einfach eine Klasse für sich. Schon beim Betreten der Halle hatte ich das Gefühl, am absolut richtigen Ort zu sein. Die Fahrzeuge perfekt gepflegt, makellos sauber und in einem Zustand, der fast schon unwirklich gut ist. Keine Hektik, kein Druck, kein Verkaufsgeschwätz. Stattdessen echte Beratung, echtes Interesse und echtes Verständnis. Eine absolute Herzensempfehlung!" },
      { name: "Tacettin Cetinkaya", stars: 5, text: "Ich habe vor Kurzem bei AD MOTORS ein Auto gekauft und bin rundum zufrieden! Vom ersten Moment an wurde ich sehr freundlich und kompetent beraten. Der gesamte Kaufprozess verlief reibungslos und unkompliziert. Besonders beeindruckt hat mich die transparente Kommunikation und die ehrliche Beratung ohne jeglichen Druck." },
      { name: "Mirza Sejdic", stars: 5, text: "Toller Händler, die Autos sind sehr sauber und so wie beschrieben, der Inhaber ist sehr kompetent und kundenorientiert. Das ist bestimmt nicht das letzte Auto, das ich hier gekauft habe. Immer wieder gerne, vielen Dank. Absolut empfehlenswert!" },
      { name: "Peter Wagner", stars: 5, text: "Ich habe bei Ihnen schon mein 2. Fahrzeug erworben. Bin sehr zufrieden mit dem Service und allem drum und dran. Sehr ehrlich, offen und hilfsbereit. Einfach zum Weiterempfehlen!" },
      { name: "Guenter Tophoven", stars: 5, text: "Kompetente und freundliche Beratung. Von detaillierten Antworten auf Fragen zum Fahrzeug inkl. Videos bis zur Hilfe beim Aufladen für den Transport. Besser geht es nicht." },
      { name: "Rene Vonasek", stars: 5, text: "Hier wird Kundenzufriedenheit an oberster Stelle geschrieben, egal ob Kauf oder Verkauf – alles aus einer Hand! Die Fahrzeuge sind absolut top und alles läuft sehr transparent ab. Sehr empfehlenswert, gerne wieder!" },
    ],
  },
  waVehicle: (v, url) => {
    const facts = vehicleFacts(v);
    return `Hallo AD Motors, ich interessiere mich für den ${vehicleLabel(v)}${facts ? ` (${facts})` : ""} auf Ihrer Website. Ist das Fahrzeug noch verfügbar?\n${url}`;
  },
};

export const DEALERS = { autohaus, admotors };

export const DEALER = DEALERS[process.env.REACT_APP_DEALER];
